import React, { useEffect, useMemo, useRef } from 'react';
import { ReferenceMarkup } from './ReferenceMarkup';
import { createReferenceViews } from './referenceViews';
import { createMissionController } from './missionController';

export const Mission = ({ lang }) => {
  const host = useRef(null);
  const controller = useRef(null);
  const views = useMemo(() => createReferenceViews(lang), [lang]);
  const tr = (mr, en) => lang === 'mr' ? mr : en;
  useEffect(() => {
    const root = host.current.querySelector('#mission');
    controller.current = createMissionController(root, (mr, en) => lang === 'mr' ? mr : en, views, window.matchMedia('(prefers-reduced-motion: reduce)'));
    return () => { controller.current?.destroy(); controller.current = null; };
  }, [lang, views]);
  const action = (name, args, event) => {
    if (name === 'selectMission') controller.current?.select(args[0]);
    if (name === 'toggleMission') controller.current?.toggle();
    if (name === 'scrubMission') controller.current?.scrub(event.target.value);
  };
  return <div ref={host} className="mission-host" data-testid="mission-host"><ReferenceMarkup html={views.missionSection()} prefix="mission" tr={tr} onAction={action} /></div>;
};